<h2 mat-dialog-title>
  Sélectionner un CNEH
</h2>
<app-list-cneh
  [actions]="['select', 'search']"
  (select)="close($event)">
</app-list-cneh>
